import storeInit from "storeInit";
import {get, isArray} from "lodash";
import isWorker from "utils/isWorker";


export default function workerHasPrivilege(privilegePath){
  const state = storeInit.getState();

  if(!isWorker()){
    return true;
  }

  let result = false;

  if(isArray(privilegePath)){
    privilegePath.forEach(privilegePath => {
      if(get(state.worker.privilege, privilegePath)){
        result = true
      }
    })
  }else{
    result = get(state.worker.privilege, privilegePath)
  }

  return result
}